export const PLAN_TYPES:any = {
	basic: 'basic',
	pro: 'pro',
	individual: 'individual',
	professional: 'professional',
	business: 'business',

	invoice_basic: "invoice-basic",
	invoice_pro: "invoice-pro",
	invoice_enterprise: "invoice-enterprise",
	online_store_basic: "online-store-basic",
	online_store_pro: "online-store-pro",
	online_store_enterprise: "online-store-enterprise",
	online_ordering_basic: "online-ordering-basic",
	online_ordering_pro: "online-ordering-pro",
	online_ordering_enterprise: "online-ordering-enterprise",
	complete_solution: "complete-solution"
}

export const PLAN_FREQUENCY = {
	monthly: 'monthly',
	yearly: 'yearly'
}

export const PLAN_PRICES = {
	monthly: {
		basic: 9,
		pro: 39,
		individual: 9,
		professional: 39,
		business: 69,

		"invoice-basic": 10,
		"invoice-pro": 30,
		"invoice-enterprise": 50,
		"online-store-basic": 70,
		"online-store-pro": 80,
		"online-store-enterprise": 100,
		"online-ordering-basic": 70,
		"online-ordering-pro": 80,
		"online-ordering-enterprise": 100,
		"complete-solution": 119.99,
	},
	yearly: {
		basic: 90,
		pro: 390,
		individual: 90,
		professional: 390,
		business: 690,

		"invoice-basic": 96,
		"invoice-pro": 289,
		"invoice-enterprise": 479.99,
		"online-store-basic": 669.99,
		"online-store-pro": 769,
		"online-store-enterprise": 959.99,
		"online-ordering-basic": 669.99,
		"online-ordering-pro": 769,
		"online-ordering-enterprise": 959.99,
		"complete-solution": 1149.99,
	}
}

export const SUBSCRIPTION_STATUS = {
	active: 'active',
	free: 'free'
}

export const USER_TYPE:any = {
	user: 'user',
	admin: 'admin',
	super_admin: 'super_admin',
}

export const TAP_PAYMENT_PUBLIC_KEY = (window as any).TAP_PAYMENT_PUBLIC_KEY;